module.exports = __webpack_public_path__ + "img/see.54c54ce9.jpg";